module.exports = __webpack_public_path__ + "img/desconto.1c05c198.svg";